import { __assign } from "tslib";
import React from 'react';
import Icon from '../Icon';
/* eslint-disable */
/* tslint:disable */
var CloseThin = function (props) { return (React.createElement(Icon, __assign({ viewBox: "-2.4 21.6 9.7 9.7" }, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M7.3 22.4l-.7-.8-4.1 4.2-4.1-4.2-.8.8 4.2 4.1-4.2 4.1.8.7 4.1-4.1 4.1 4.1.7-.7-4.1-4.1z", className: "st0" })))); };
/* tslint:enable */
/* eslint-enable */
export default CloseThin;
//# sourceMappingURL=CloseThin.js.map